import { createAsyncThunk } from "@reduxjs/toolkit";
import userService from "../../../api/services/user";

export const fetchUserInfo = createAsyncThunk(
  "user/fetch-user-info",
  async (_, { rejectWithValue }) => {
    try {
      return await userService.fetchUserInfo();
    } catch (err) {
      return rejectWithValue({ message: err.message, status: err.status });
    }
  },
);

export const addDailyCredits = createAsyncThunk(
  "user/add-daily-credits",
  async () => {
    return await userService.addDailyCredits();
  },
);

export const spinTheWheel = createAsyncThunk("user/spin-wheel", async () => {
  return await userService.spinTheWheel();
});

export const changeUsername = createAsyncThunk(
  "user/set-username",
  async (requestData) => {
    return await userService.setUsername(requestData);
  },
);

export const deleteAccount = createAsyncThunk(
  "user/delete-account",
  async (requestData) => {
    return await userService.deleteAccount(requestData);
  },
);

export const getReferralUsers = createAsyncThunk(
  "user/referral-users",
  async () => {
    return await userService.getReferralUsers();
  },
);

export const getSameAuthorCollections = createAsyncThunk(
  "user/get-same-author-collections",
  async (userId) => {
    return await userService.getSameAuthorCollections(userId);
  },
);

export const submitRequest = createAsyncThunk(
  "user/submit-request",
  async (requestData) => {
    return await userService.submitRequest(requestData);
  },
);

export const getUserData = createAsyncThunk(
  "user/get-user-data",
  async (userId, { rejectWithValue }) => {
    try {
      return await userService.getUserData(userId);
    } catch (err) {
      return rejectWithValue({ message: err.message, status: err.status });
    }
  },
);

export const getUserCollectionsData = createAsyncThunk(
  "user/get-user-collections-data",
  async ({ username, page = 1 }, { rejectWithValue }) => {
    try {
      return await userService.getUserCollectionsData({ username, page });
    } catch (err) {
      return rejectWithValue({ message: err.message, status: err.status });
    }
  },
);

export const updateProfile = createAsyncThunk(
  "user/update-profile",
  async (requestData, { rejectWithValue }) => {
    try {
      return await userService.updateProfile(requestData);
    } catch (err) {
      return rejectWithValue({ message: err.message, status: err.status });
    }
  },
);

export const getFollowers = createAsyncThunk(
  "user/get-followers",
  async (params, { rejectWithValue }) => {
    try {
      return await userService.getFollowers(params);
    } catch (err) {
      return rejectWithValue({ message: err.message, status: err.status });
    }
  },
);

export const getFollowing = createAsyncThunk(
  "user/get-following",
  async (params, { rejectWithValue }) => {
    try {
      return await userService.getFollowing(params);
    } catch (err) {
      return rejectWithValue({ message: err.message, status: err.status });
    }
  },
);

export const toggleFollow = createAsyncThunk(
  "user/toggle-follow",
  async (userId, { rejectWithValue }) => {
    try {
      return await userService.toggleFollow(userId);
    } catch (err) {
      return rejectWithValue({ message: err.message, status: err.status });
    }
  },
);
